import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

export interface UserProfile {
  firstName?: string;
  lastName?: string;
  role?: string;
  avatarImage?: string;
}

@Component({
  selector: "app-user-profile-with-avatar",
  templateUrl: "./user-profile-with-avatar.component.html",
  styleUrls: ["./user-profile-with-avatar.component.scss"],
  imports: [CommonModule]
})
export class UserProfileWithAvatarComponent {
  @Input() user: UserProfile | null = {};

  get displayName(): string | null {
    if (!this.user) return null;

    if (this.user.firstName && this.user.lastName) {
      return `${this.user.firstName} ${this.user.lastName}`;
    } else if (this.user.firstName) {
      return this.user.firstName;
    } else if (this.user.lastName) {
      return this.user.lastName;
    }
    return null;
  }

  get avatarInitials(): string | null {
    if (!this.user) return null;

    if (this.user.firstName && this.user.lastName) {
      return this.user.firstName.charAt(0).toUpperCase() + this.user.lastName.charAt(0).toUpperCase();
    } else if (this.user.firstName) {
      return this.user.firstName.charAt(0).toUpperCase();
    } else if (this.user.lastName) {
      return this.user.lastName.charAt(0).toUpperCase();
    }
    return null;
  }

  get hasAvatar(): boolean {
    return !!(this.user?.avatarImage) && this.user?.avatarImage?.length > 0;
  }
} 